function cell(sub) {
  let data = JSON.parse(window.localStorage.getItem('cell'))
  for (let i = 0; i < data.length; i++){
    if (data[i].value == sub) {
      console.log(data[i].name)
      return data[i].name
    }
  }
}
export {cell}